module.exports = __webpack_public_path__ + "static/NeueMontreal-Regular-503c82749488260cd921be57e1b32d06.woff2";